import { useState } from "react";
import { getAllUsers as apiGetAllUsers } from "../api/Users";
import { useToast } from "../components/Toast";

const useUser = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const { addToast } = useToast();

  const getAllUsers = async (page, limit) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const data = await apiGetAllUsers(token, page, limit);
      setUser(data);
    } catch (error) {
      addToast(error?.response?.data?.detail || "Failed to fetch users", {
        appearance: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return { loading, user, getAllUsers };
};

export default useUser;
